<template>
  <el-select :value="value" class="select" :placeholder="$t('shared.pleaseSelectServiceCoverage')"
    v-bind:disabled="disabled" @change="$emit('input', $event)">
    <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
  </el-select>
</template>

<script>
export default {
  name: 'service-coverage-selector',
  props: {
    value: {},
    disabled: {}
    ,
    forExclude: {
      type: String,
      default: ""
    },
  },
  data(vm) {
    var roles = [
      {
        id: '1',
        name: vm.$t('common.warrantyInvoiceHardt')
      },
      {
        id: '2',
        name: vm.$t('common.costcoNonWarrantyInvoiceHardt')
      },
      //{
      //  id: '3',
      //  name: 'Costco Preventative Maintenance, Invoice Hardt'
      //},
      {
        id: '4',
        name: vm.$t('common.walMartNonWarrantyInvoiceHardt')
      },
      {
        id: '5',
        name: vm.$t('common.pendingWarrantyInvoiceHardtPendingDecision')
      },
      {
        id: '6',
        name: vm.$t('common.warrantyExceptionInvoiceHardt')
      },
      {
        id: '7',
        name: vm.$t('common.installationPostInstall')
      },
      {
        id: '8',
        name: vm.$t('common.nonWarrantyInvoiceHardt')
      }
    ];
    return {
      loading: false,
      roles: roles.filter(x => !this.forExclude.split(',').find(y => y == x.id))
    }
  }
}
</script>

<style scoped>
.select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/ServiceCoverageSelector.vue